import React, { Component } from "react";
import { translate } from "react-i18next";
import BannerTop from "../../components/bannertop/bannertop.component";
import PrivacyText from "../../components/privacyText/privacy.component";
import { Helmet } from "react-helmet";

class Privacy extends Component {
  UNSAFE_componentWillUpdate() {
    const requestLang = window.location.pathname.split("/");
    const size = requestLang.length - 1;

    if (requestLang[size] === "") {
      let url =
        "/" + this.props.i18n.language + "/" + this.props.t("privacidade");
      this.props.history.replace(url, true);
    }

    let lang = requestLang[1];

    if (lang !== this.props.i18n.language) {
      let url =
        "/" + this.props.i18n.language + "/" + this.props.t("privacidade");
      this.props.history.replace(url, true);
    }
  }

  render() {
    let { t, i18n } = this.props;

    return (
      <div id="start">
        <Helmet>
          <title>Política de Privacidade</title>
          <meta
            name="description"
            content="As empresas que façam parte da Rede de Restaurantes Portugueses no Mundo passam a ser verdadeiros agentes de divulgação, promoção e “venda” de Portugal, nomeadamente, através da dinamização do nosso artesanato, dos nossos produtos e da nossa própria cultura, e também atraindo turistas a Portugal, enquanto dignos representantes da Gastronomia Tradicional Portuguesa."
          />
        </Helmet>
        <BannerTop t={t} type={3} title={t("privacidade")} i18n={i18n} />
        <PrivacyText t={t} />
      </div>
    );
  }
}

export default translate("translations")(Privacy);



// WEBPACK FOOTER //
// ./src/pages/privacy/privacy.page.js